import { Form, Select } from 'antd';
import { useState, useEffect } from 'react';
import { AxiosResponse } from 'axios';
import Swal from 'sweetalert2';
import { UDNICK } from '../../../../../service/udnick';
import { CentrosDistribuicaoType } from './types';

const CentroDistribuicao: React.FC<CentrosDistribuicaoType> = ({ required, label, name }) => {
  const { Option } = Select;
  const [response, setResponse] = useState([]);

  const centrosDist = {
    getCentrosDistribuicao: (): Promise<AxiosResponse> =>
      UDNICK.callService('getCentrosDistribuicao'),
  };

  useEffect(() => {
    try {
      centrosDist.getCentrosDistribuicao().then((res) => {
        setResponse(res.data.centrosDistribuicao);
      });
    } catch (error) {
      Swal.fire({
        title:
          'Não foi possivel carregar a lista dos centros de distribuições, por favor atualize a página!',
        html: '',
        icon: 'warning',
        showConfirmButton: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (values: any) => {
    localStorage.setItem(`CentroDistribuicao${window.location.pathname}`, values);
  };

  return (
    <>
      <Form.Item
        label={label}
        name={name ? name : 'centroDistribuicao'}
        rules={[{ required: required, message: 'Por favor preencha este campo' }]}
      >
        <Select
          data-cy="centroDistribuicao"
          onChange={onChange}
          style={{ width: '100%' }}
          showSearch
          optionFilterProp={'children'}
          filterOption={(input, option) =>
            option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {response?.map((item: any) => (
            <Option value={item.codCdd} key={item.codCdd}>
              {item.nomeFantasia}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default CentroDistribuicao;
